export default "__VITE_ASSET__f7d3bce9__"